import React from 'react';

export function GroupsIcon() {
  return (
    <svg stroke="currentColor" width="17" height="16" viewBox="0 0 17 16" fill="none">
      <circle cx="8.92688" cy="3.63132" r="2.375" strokeWidth="1.5" />
      <path d="M13.6469 4.37965C14.6813 4.76699 15.3235 7.03139 14.9362 8.06582" strokeWidth="1.5" />
      <path d="M4.35309 4.37965C3.31866 4.76699 2.67651 7.03139 3.06384 8.06582" strokeWidth="1.5" />
      <path d="M10.3408 14.2531C9.75237 14.8415 8.11813 14.7799 7.50903 14.1708" strokeWidth="1.5" />
      <circle cx="4.00195" cy="12.251" r="2.375" strokeWidth="1.5" />
      <circle cx="13.8478" cy="12.251" r="2.375" strokeWidth="1.5" />
    </svg>
  );
}
